<h2 mat-dialog-title>Attachments</h2>

<mat-dialog-content fxFlex="auto" style="height:45vh">
    <attachments-container [canEdit]="canEdit" [entityType]="entityType" [canAdd]="true" [model]="attachments" (delete)="onDelete($event)" (add)="addAttachment($event)">
    </attachments-container>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end">
    <command-bar [commands]="commands">
    </command-bar>
</mat-dialog-actions>
